import { render, staticRenderFns } from "./AddEditRoomPopup.vue?vue&type=template&id=2570312c"
import script from "./AddEditRoomPopup.vue?vue&type=script&lang=ts"
export * from "./AddEditRoomPopup.vue?vue&type=script&lang=ts"
import style0 from "./AddEditRoomPopup.vue?vue&type=style&index=0&id=2570312c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports